<template>

<div class="scan">

	<com-webcam ref="cam" :selectFirstDevice="true" />

    <div class="scan-buttons">

        <div class="scan-buttons-item" v-tooltip="'Cancel'" v-on:click="$emit('close')"><app-icon icon="crossOnly" /></div>
        <div class="scan-buttons-item" v-tooltip="'Take photo'" v-on:click="onTakeClick"><app-icon icon="photo" /></div>

    </div>
    
</div>

</template>

<script>

import { WebCam } from 'vue-web-cam'

export default {

    components: {
        'com-webcam': WebCam
    },

    methods: {
    
        onTakeClick: function() {
        
            this.$emit('capture', this.$refs.cam.capture())
        
        }
    
    }

}

</script>

<style scoped>

.scan {
	position: fixed;
	top: 0px;
	left: 0px;
	right: 0px;
	bottom: 0px;
	background-color: #000;
	z-index: 100000;
}

.scan video {
    position: absolute;
    left: 0px;
    top: 0px;
    width: 100%;
    height: 100%;
    z-index: 1;
}

.scan-buttons {
    position: absolute;
    left: 50%;
    bottom: 32px;
    height: 48px;
    z-index: 2;
    transform: translateX(-50%);
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-gap: 10px;
}

.scan-buttons-item {
	background-color: #4082d3;
    width: 120px;
    height: 48px;
    border-radius: 10px;
    line-height: 48px;
    text-align: center;
    color: #fff;
    font-size: 24px;
    cursor: pointer;
}

</style>
